{% block ecocode_trustpilot_first_run_wizard_modal %}
    <sw-modal :title="title"
        :variant="variant"
        refs="modal"
        v-if="show"
        @modal-close="close"
        class="ecocode-trustpilot-first-run-wizard-modal">
        {% block ecocode_trustpilot_first_run_wizard_modal_content %}
            <div class="ecocode-trustpilot-first-run-wizard-modal-content">
                <sw-container v-bind:class="{'one': !showSteps, 'two': showSteps}"
                              class="ecocode-trustpilot-first-run-wizard-modal-content__columns">
                    {% block ecocode_trustpilot_first_run_wizard_modal_content_steps %}
                        <div v-if="showSteps"
                             class="ecocode-trustpilot-first-run-wizard-modal-content__steps">
                            <sw-step-display :itemIndex="stepIndex"
                             :itemVariant="stepVariant"
                             :initialItemVariants="stepInitialItemVariants">
                                <sw-step-item>
                                    {{ $tc('ecocode-trustpilot.stepItemTitle.connect') }}
                                </sw-step-item>
                                <sw-step-item>
                                    {{ $tc('ecocode-trustpilot.stepItemTitle.configure') }}
                                </sw-step-item>
                                <sw-step-item>
                                    {{ $tc('ecocode-trustpilot.stepItemTitle.invitation') }}
                                </sw-step-item>
                            </sw-step-display>
                        </div>
                    {% endblock %}

                    {% block ecocode_trustpilot_first_run_wizard_modal_content_page %}
                        <div class="ecocode-trustpilot-first-run-wizard-modal-content__page">
                            <router-view
                                    v-slot="{ Component }"
                            >
                                <component
                                        :is="Component"
                                        @buttons-update="updateButtons"
                                        @frw-redirect="redirect"
                                        @frw-set-title="setTitle"
                                        @modal-close="close"
                                />
                            </router-view>

                        </div>
                    {% endblock %}
                </sw-container>
            </div>
        {% endblock %}

        {% block ecocode_trustpilot_first_run_wizard_modal_footer %}
            <template #modal-footer>
                <div class="ecocode-trustpilot-first-run-wizard-modal__footer">
                    {% block ecocode_trustpilot_first_run_wizard_modal_footer_left %}
                        <div class="footer-left">
                            <sw-button v-for="button in buttons.left"
                                        :key="button.key"
                                        @click="onButtonClick(button.action)"
                                        :variant="button.variant"
                                        :disabled="button.disabled"
                                        size="small">
                                        {{ button.label }}
                            </sw-button>
                        </div>
                    {% endblock %}

                    {% block ecocode_trustpilot_first_run_wizard_modal_footer_right %}
                        <div class="footer-right">
                            <sw-button v-for="button in buttons.right"
                                       :key="button.key"
                                       @click="onButtonClick(button.action)"
                                       :variant="button.variant"
                                       :disabled="button.disabled"
                                       size="small">
                                {{ button.label }}
                            </sw-button>
                        </div>
                    {% endblock %}
                </div>
            </template>
        {% endblock %}
    </sw-modal>
{% endblock %}
